<template>
	<div>
		<div class="features" style="height: 480px;background-color: #f6f6f6;padding-bottom: 40px;">
			<div class="content modle-box" style="justify-content: space-between;">
				<div class="describe" style="margin-bottom: 20px;margin-top: 30px;">
					<div class="line-1">你知道?</div>
					<div class="line-2"></div>
				</div>
				<div style="width: 915px;font-size: 18px;color: #F03E2E;text-align: center;">
					<div>高校学生当之无愧“快递主力军”！</div>
				</div>
				<img style="width: 717px;height: 333px;" src="../image/you-know.png" />
			</div>
		</div>

		<div class="modle" style="height: 600px;">
			<div class="content modle-box" style="flex-direction:row;justify-content: space-between;height: 600px;">
				<div class="describe" style="justify-content: space-between;">
					<div class="line-1" style="color:#F03E2E;margin-bottom: 20px; width: 650px;">“代取快递经济”崛起,瓜分校园快递市场蛋糕,等你来加入！</div>
					<!-- <div class="line-2"></div> -->
					<div class="line-3" style="font-size: 16px;color:#F03E2E">政策福利加持,年营业额轻松破千万！</div>
					<div class="line-4" style="font-size: 14px;">
						学生取快递,比取经还难！</br>
						狂风雨雪天气,等取快递,欲哭无泪！</br>
						课业繁忙,哪有时间排队取快递？</br>
						快递点分散,横穿半个校园,一个人取件费时又费力！</br>
						快递多又重,怎能抬得动？</br>
						电商大促快递成山,茫茫包裹找件难！</br>
						……</br>
						学生快递代取,急需！急需！急需！</br>
					</div>
				</div>
				<img src="../image/zhaoshang_kuaidi@2x.png" style="width: 606px;height: 433px;" />
			</div>
		</div>

		<div style="width: 100%;position: relative;">
			<img src="../image/zhaoshang_beijing@2x.png" style="width: 100%;height: 600px;object-fit: cover;" />
			<div style="position: absolute;top: 200px;left: 0px;right: 0px;margin: 0 auto;text-align: center;font-size: 80px;color: #FFFFFF;width: 1200px;">
				每个城市仅开放
				<span style="font-size: 120px;color:#F03E2E" >1</span>
				名合伙人名额
			</div>
			<div style="position: absolute;top: 400px;left: 0px;right: 0px;margin: 0 auto;text-align: center" >
				<img style="width: 237px;height: 63px;" src="../image/zhaoshang_woyaodaili@2x.png" @click="jumpBottom" />
			</div>
		</div>

		<div class="features" style="height: 800px;background-color: #f6f6f6;padding-bottom: 40px;">
			<div class="content modle-box" style="justify-content: space-between;">
				<div class="describe" style="margin-bottom: 20px;margin-top: 30px;">
					<div class="line-1">专业的代理商扶持计划,合作无后顾之忧</div>
					<div class="line-2"></div>
				</div>
				<div class="zy-box">
					<div class="zy-item">
						<img src="../image/zhaoshang_peixun@2x.png" style="width: 88px;height: 88px;margin-bottom: 70px;" />
						<div style="font-size: 16px;margin-bottom: 36px;">产品培训支持</div>
						<div style="font-size: 14px;margin-bottom: 36px;">产品培训和运营技巧全方位输出</div>
					</div>
					<div class="zy-item">
						<img src="../image/zhaoshang_tuiguang@2x.png" style="width: 88px;height: 88px;margin-bottom: 70px;" />
						<div style="font-size: 16px;margin-bottom: 36px;">推广资料支持</div>
						<div style="font-size: 14px;margin-bottom: 36px;">
							公司提供最新、最全的物料支持，快速占领市场
						</div>
					</div>
					<div class="zy-item">
						<img src="../image/zhaoshang_xianshang@2x.png" style="width: 88px;height: 88px;margin-bottom: 70px;" />
						<div style="font-size: 16px;margin-bottom: 36px;">线上推广支持</div>
						<div style="font-size: 14px;margin-bottom: 36px;">线上推广方案、活动、服务支持。</div>
					</div>
					<div class="zy-item">
						<img src="../image/zhaoshang_1v1@2x.png" style="width: 88px;height: 88px;margin-bottom: 70px;" />
						<div style="font-size: 16px;margin-bottom: 36px;">总监1v1支持</div>
						<div style="font-size: 14px;margin-bottom: 36px;">
							市场总监全程跟进,专项解决伙伴业经营难题
						</div>
					</div>
					<div class="zy-item">
						<img src="../image/zhaoshang_meiti@2x.png" style="width: 88px;height: 88px;margin-bottom: 70px;" />
						<div style="font-size: 16px;margin-bottom: 36px;">媒体宣传支持</div>
						<div style="font-size: 14px;margin-bottom: 36px;">媒体渠道及推广报道助理产品宣传</div>
					</div>
					<div class="zy-item">
						<img src="../image/zhaoshang_wuchang@2x.png" style="width: 88px;height: 88px;margin-bottom: 70px;" />
						<div style="font-size: 16px;margin-bottom: 36px;">无偿培训支持</div>
						<div style="font-size: 14px;margin-bottom: 36px;">
							总公司为伙伴提供免费提供经营管理培训
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="features" style="height: 400px;padding-bottom: 40px;">
			<div class="content modle-box" style="justify-content: space-between;">
				<div class="describe" style="margin-bottom: 20px;margin-top: 30px;">
					<div class="line-1">成为伙伴的流程</div>
					<div class="line-2"></div>
				</div>
				<div class="hb-box">
					<div class="hb-item">
						<img src="../image/zhaoshang_chuangye@2x.png" style="width: 122px;height: 122px;margin-bottom: 40px;" />
						<div style="font-size: 16px;margin-bottom: 36px;width: 200px;">坚定创业心并联系我们</div>
					</div>
					<div class="hb-arrow">
						<img src="../image/zhaoshang_jiantou@2x.png" style="width: 24px;height: 15px;margin-bottom: 70px;" />
					</div>
					<div class="hb-item">
						<img src="../image/zhaoshang_tianxie@2x.png" style="width: 122px;height: 122px;margin-bottom: 40px;" />
						<div style="font-size: 16px;margin-bottom: 36px;width: 200px;">填写、提交《代理商申请表》</div>
					</div>
					<div class="hb-arrow">
						<img src="../image/zhaoshang_jiantou@2x.png" style="width: 24px;height: 15px;margin-bottom: 70px;" />
					</div>
					<div class="hb-item">
						<img src="../image/zhaoshang_qudao@2x.png" style="width: 122px;height: 122px;margin-bottom: 40px;" />
						<div style="font-size: 16px;margin-bottom: 36px;width: 200px;">
							渠道专员进行考察、评估、分析,营销部进行审核
						</div>
					</div>
					<div class="hb-arrow">
						<img src="../image/zhaoshang_jiantou@2x.png" style="width: 24px;height: 15px;margin-bottom: 70px;" />
					</div>
					<div class="hb-item">
						<img src="../image/zhaoshang_shenhe@2x.png" style="width: 122px;height: 122px;margin-bottom: 40px;" />
						<div style="font-size: 16px;margin-bottom: 36px;width: 200px;">审核无误签订协议,执行代理合作</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modle" style="background-color: #f1f1f1;height: 487px;">
			<div class="content modle-box" style="height: 487px;">
				<div class="describe" style="margin-bottom: 20px;margin-top: 30px;display: flex;flex-direction: column;align-items: center;">
					<div class="line-1">联系我们</div>
					<div class="line-2"></div>
				</div>
				<img src="../image/zhaoshang_erweima@2x.png" style="width: 288px;height: 288px;" />
				<div style="font-weight: bold;margin-top: 30px;margin-bottom: 30px;">联系电话：18640580122</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {
			// hideLoading()
		},
		methods: {
			jumpBottom(){
				window.s
			}
		}
	}
</script>

<style lang="less" scoped>
	.zy-box {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.zy-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			border-right: 4px solid #FFFFFF;
			width: 33%;
			height: 328px;
			justify-content: center;
			border-bottom: 4px solid #ffffff
		}

		.zy-item:nth-child(3n) {
			border-right: none;
		}

		.zy-item:nth-child(4) {
			border-bottom: none;
		}

		.zy-item:nth-child(5) {
			border-bottom: none;
		}

		.zy-item:nth-child(6) {
			border-bottom: none;
		}
	}

	.hb-box {
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.hb-item {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
	}

	.features {
		width: 100%;
		height: 480px;

		.modle-box {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;

			.describe {
				margin-bottom: 30px;
				display: flex;
				flex-direction: column;
				align-items: center;

				.line-1 {
					font-size: 24px;
					font-weight: bold;
					color: #333333;
					margin-bottom: 5px;
				}

				.line-2 {
					width: 115px;
					height: 5px;
					border-radius: 3px;
					background-color: #f03E2E;
					margin-bottom: 10px;
				}
			}

			.item-box {
				display: flex;
				justify-content: space-between;
				width: 100%;

				img {
					width: 88px;
					height: 88px;
				}
			}


		}
	}


	.modle {
		height: 900px;
	}

	.modle-box {
		height: 900px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
</style>
